import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  // '& .MuiDialogContent-root': {
  //   padding: theme.spacing(2),
  // },
  // '& .MuiDialogActions-root': {
  //   padding: theme.spacing(1),
  // },
}));

const Span = styled(Typography)({
  fontSize: "18px",
  fontWeight: "bold",
  textAlign: "center",
  border: "none",
});

const CustomDialogWithoutCloseIcon = ({ open, onClose, children, height, width }) => {
  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{ sx: { width: width, height: height } }}
    >
      <DialogContent>{children}</DialogContent>
    </BootstrapDialog>
  );
};

export default CustomDialogWithoutCloseIcon;
